import { cn } from '@/lib/utils'

/** rounded on/off answer used by the capability, measurement and quality
 *  steps. amber outline marks a selected row that still owes an answer. */
export function TogglePill({
  label,
  selected,
  missing,
  className,
  onClick
}: {
  label: string
  selected: boolean
  missing?: boolean
  className?: string
  onClick: () => void
}) {
  return (
    <button
      type='button'
      onClick={onClick}
      aria-pressed={selected}
      className={cn(
        'inline-flex min-h-11 cursor-pointer items-center justify-center rounded-full border px-3 text-[12px] font-medium transition-colors sm:min-h-0 sm:py-1',
        selected
          ? 'border-accent bg-accent text-white'
          : 'bg-page text-ink hover:border-accent/40 hover:bg-cream/40',
        !selected &&
          (missing
            ? 'border-amber-400 dark:border-amber-600'
            : 'border-border'),
        className
      )}
    >
      {label}
    </button>
  )
}
